import { Modal } from "react-bootstrap";
import { XCircle, CheckCircle } from "react-bootstrap-icons";

const ScheduleModal = ({ show, handleClose, text, target }) => {
  const redirectingHome = () => {
    window.location = '/';
  }
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h5>{text}</h5>
        {target === 'delete' ? 
        (
          <>
            <CheckCircle 
              size={40} 
              className="text-color-green mt-3 btn-ok"
              style={{ cursor: 'pointer' }}
              onClick={handleClose} 
            />
            <XCircle 
              size={40} 
              className="text-danger mt-3"
              style={{ cursor: 'pointer' }}
              onClick={handleClose} 
            />
          </>
        ) : target === 'confirm-delete' ? 
        (
          <XCircle 
            size={40} 
            className="text-danger mt-3"
            style={{ cursor: 'pointer' }}
            onClick={redirectingHome} 
          />
        ) : target === 'no-schedule' ? 
        (
          <XCircle 
          size={40} 
          className="text-danger mt-3"
          style={{ cursor: 'pointer' }}
          onClick={handleClose} 
        />
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default ScheduleModal;
